var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2091_20509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3245 8.66081C13.3245 11.9919 10.9927 13.6575 8.22123 14.6235C8.0761 14.6727 7.91846 14.6703 7.77486 14.6169C4.9967 13.6575 2.66492 11.9919 2.66492 8.66081V3.99723C2.66492 3.82054 2.73511 3.65108 2.86005 3.52614C2.98499 3.4012 3.15445 3.33101 3.33114 3.33101C4.66359 3.33101 6.32915 2.53154 7.48839 1.51887C7.62953 1.39829 7.80908 1.33203 7.99472 1.33203C8.18036 1.33203 8.35991 1.39829 8.50105 1.51887C9.66694 2.5382 11.3258 3.33101 12.6583 3.33101C12.835 3.33101 13.0044 3.4012 13.1294 3.52614C13.2543 3.65108 13.3245 3.82054 13.3245 3.99723V8.66081Z",
    stroke: "#D1D5DC",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2091_20509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9894,
    height: 15.9894,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldWhite);
export default __webpack_public_path__ + "static/media/shield_white.8d83642d7e4b8647ebf4371be12c35ee.svg";
export { ForwardRef as ReactComponent };